<template>
  <div id="transferDetails">
    <vs-popup id="DestroyBatchPlants" class="text-center" title="Transfer Details " button-accept="false" button-cancel="false" :active.sync="isActive">
      <vs-table id="table-loading" class="vs-con-loading__container" stripe :sst="true" maxHeight="500px" :data="(transferDetail && transferDetail.transferProducts) || []">
        <template slot="thead">
          <vs-th>Sr # </vs-th>
          <vs-th>Category </vs-th>
          <vs-th>Batch Number </vs-th>
          <vs-th>Product Name</vs-th>
          <vs-th>Sales Price </vs-th>
          <vs-th>Weight Type </vs-th>
          <vs-th>Weight Per Package </vs-th>
          <vs-th>Quantity </vs-th>
          <vs-th>Purchase Price </vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>{{ tr.product && tr.product.category && tr.product.category.category_name }}</vs-td>
            <vs-td>{{ tr.product && tr.product.batch && tr.product.batch.batch_number }}</vs-td>
            <vs-td>{{ tr.product && tr.product.product_name }}</vs-td>
            <vs-td>{{ tr.product && tr.product.sales_price }}</vs-td>
            <vs-td>{{ tr.weight_type }}</vs-td>
            <vs-td>{{ (isFlowerOrshake(tr.product.categoryId) && tr.product && tr.product.weight_per_package) || 0 }}</vs-td>
            <vs-td>{{ (!isFlowerOrshake(tr.product.categoryId) && tr.quantity) || 0 }}</vs-td>
            <vs-td>{{ tr.product && tr.product.purchase_price }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'ViewTransferDetails',

  props: {
    showModal: Boolean,
    transferId: Number
  },

  data() {
    return {
      transferDetail: null,
      length: 10
    }
  },

  async mounted() {
    await this.getTransferDetail()
  },

  computed: {
    ...mapState('product', ['categories']),

    // close the poup
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    },

    isFlowerOrshake() {
      return (categoryId) => {
        return [this.categories.FLOWER, this.categories.SHAKE].includes(categoryId)
      }
    }
  },

  methods: {
    ...mapActions('transfer', ['getViewTransferDetailsById']),

    getTransferDetail() {
      this.loading = true

      this.$store
        .dispatch('transfer/getViewTransferDetailsById', this.transferId)
        .then((res) => {
          this.transferDetail = res.data.transfer
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // sync transfer list
    async syncTransfer(syncDate) {
      await this.syncList({
        date: syncDate
      })
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    // complete transfer
    completeTransfer(data) {
      this.selectedTransferId = data.id
      this.completeTransferModalShow = true
    },

    // delete transfer
    deleteTransferConfirmation(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => {
          this.deleteTransfer(id)
        },
        acceptText: 'Delete'
      })
    },

    // delete transfer
    async deleteTransfer(id) {
      try {
        await this.deleteTransferRecord(id)

        this.$vs.notify({
          title: 'Success',
          text: 'Transfer deleted successfully!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.page = 1
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // view transfer details modal
    viewTransferDetailModal() {
      this.isViewTransferDetailsModalMounted = true
      this.isViewTransferDetailsModalShow = true
    }
  }
}
</script>

<style >
.con-vs-popup .vs-popup {
  width: 914px;
}
</style>